{
  "leaflet": {
    "css": {
      "id": "leaflet-css",
      "href": "https://unpkg.com/leaflet@1.9.4/dist/leaflet.css",
      "integrity": "sha256-p4NxAoJBhIIN+hmNHrzRCf9tD/miZyoHS5obTRR9BMY=",
      "crossorigin": "anonymous"
    },
    "js": {
      "id": "leaflet-js",
      "src": "https://unpkg.com/leaflet@1.9.4/dist/leaflet.js",
      "integrity": "sha256-20nQCchB9co0qIjJZRGuk2/Z9VM+kNiyxNV1lvTlZBo=",
      "crossorigin": "anonymous"
    }
  },
  "maplibre": {
    "css": {
      "id": "maplibre-css",
      "href": "https://unpkg.com/maplibre-gl@5.24.0/dist/maplibre-gl.css",
      "integrity": "sha256-qx5w1Z7EBGW65+cDDaLzzPKBM/1QLmK9WY7vut/XpzI=",
      "crossorigin": "anonymous"
    },
    "js": {
      "id": "maplibre-js",
      "src": "https://unpkg.com/maplibre-gl@5.24.0/dist/maplibre-gl.js",
      "integrity": "sha256-RamwepGJzlYFTGIKlHzPQeKR5YyV6bYVM7dAqqZe5cs=",
      "crossorigin": "anonymous"
    }
  },
  "chart": {
    "js": {
      "id": "chart-js",
      "src": "https://cdn.jsdelivr.net/npm/chart.js@4.4.3/dist/chart.umd.min.js",
      "integrity": "sha256-1G2Xof0CLF+yn6L0Xry8MiAtc67r8HbOX3JI9UmPx9c=",
      "crossorigin": "anonymous"
    }
  }
}
